export default "__VITE_ASSET__BTI62PEV__"